import { useQuery } from '@tanstack/react-query';
import { fileIntegrityApi } from '../services/api';

export const useDagCounts = () => {
  return useQuery({
    queryKey: ['fileIntegrityDagCounts'],
    queryFn: async () => {
      const response = await fileIntegrityApi.getDagCounts();
      return response.data;
    },
    staleTime: 2 * 60 * 1000,
  });
};
